<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div class='h-outTabs'>
        <ejs-tab id='historyAlarmTab' ref='tabRef' :showCloseButton='true' heightAdjustMode='None' :removing='beforeRemoving' :selected='selectedTab'>
          <e-tabitems>
            <e-tabitem :header='tab.headerText' content='#historyTable' cssClass='h-tab-noClose'></e-tabitem>
            <e-tabitem :header='tab.analysisHeader' content='#analysisTable' cssClass='h-tab-noClose'></e-tabitem>
            <e-tabitem :header='tab.topHeader' content='#topTable' cssClass='h-tab-noClose'></e-tabitem>
            <e-tabitem :header='tab.headerTexts' content='#staticsChar'></e-tabitem>
          </e-tabitems>
        </ejs-tab>
        <div id='historyTable' class='h100vh-140'>
          <AlarmTableButton ref='alarmTableButton' @notice='notice' @keywords='changeKeywords'
            :refreshBtn='true' :exportBtn='exportBtnBoolean' :separatorLine='true' :showDetailBtn='showDetailBtnBoolean' :statisticsBtn='statisticsBtnBoolean' :filterBtn='filterBtnBoolean' :printBtn='printBtnBoolean'  :keywordsInput='true'></AlarmTableButton>
          <AlarmCount :roleNe='roleNetList' ref='alarmCount'></AlarmCount>
          <div class="h100vh-200 h-scroll">
            <AlarmTable :roleNe='roleNetList' @paramChange='onParamChange' ref='alarmTable'></AlarmTable>
          </div>
        </div>
        <div id='analysisTable' class='h100vh-140'>
          <div class="h100vh-200 h-scroll">
            <StaticsTable :roleNe='roleNetList'></StaticsTable>
          </div>
        </div>
        <div id='topTable' class='h100vh-140'>
          <TopChar ref='topCharRef' :roleNe='roleNetList' url='/lte/ems/fm/alarmhistory/statisticsTop' :option='charOption'></TopChar>
        </div>
        <div id='staticsChar' class='h100vh-140' style='display: none;'>
          <StaticsChar ref='staticsCharRef' :roleNe='roleNetList' url='/lte/ems/fm/alarmhistory/getStatisticsInfo' :option='charOption'></StaticsChar>
        </div>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import AlarmTableButton from '../../components/alarmconfig/currentAlarm/CurrentAlarmTableButton';
import AlarmTable from '../../components/alarmconfig/historyAlarm/HistoryAlarmTable';
import StaticsTable from '../../components/alarmconfig/historyAlarm/StaticsTable';
import StaticsChar from '../../components/alarmconfig/historyAlarm/StatisticsChar';
import TopChar from '../../components/alarmconfig/historyAlarm/TopChar';
import AlarmCount from '../../components/alarmconfig/historyAlarm/HistoryAlarmCount';


export default {
  name: 'HistoryAlarmPage',
  components: {
    BasicLayout,
    AlarmCount,
    AlarmTableButton,
    AlarmTable,
    StaticsTable,
    StaticsChar,
    TopChar
  },
  data() {
    return {
      exportBtnBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_history.Export,
      showDetailBtnBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_history.AlarmDetails,
      statisticsBtnBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_history.Statistics,
      filterBtnBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_history.Filter,
      printBtnBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_history.Print,

      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Alarm.alarmManage')}/${this.$t('Alarm.historyAlarm')}`
      },
      tab: {
        headerText: { text: this.$t('Alarm.historyAlarm') },
        analysisHeader: { text: this.$t('Alarm.analysisAlarm') },
        topHeader: { text: this.$t('Alarm.topAlarm') },
        headerTexts: { text: this.$t('Alarm.statistics') }
      },
      charOption: {
        charTitle: `${this.$t('Alarm.historyAlarm')} ${this.$t('Alarm.statistics')}`,
        allNumTitle: this.$t('Alarm.alarmNum')
      },
      roleNetMap: {},
      roleNetList: []
    };
  },
  methods: {
    changeKeywords(args) {
      this.$refs.alarmTable.queryConditions.keywords = args;
    },
    onParamChange(args) {
      // 韩洪波 2023-6-27 当参数变化时，判断过滤条件
      console.log('history alarm page, args:', args);
      let isfiltered = false;
      if (args) {
        if (args.conditions !== undefined && args.conditions !== null && args.conditions !== '') {
          // 不判断搜索关键字，关键字在过滤的外面。args.keywords;
          isfiltered = true;
        }
      }
      this.$refs.alarmTableButton.setFilered(isfiltered);
    },
    staticsTabFunc() {
      const tabObj = this.$refs.tabRef.ej2Instances;
      tabObj.hideTab(3, false);
      tabObj.select(3);
      this.$refs.staticsCharRef.getStatisData(true);
    },
    selectedTab(args) {
      if (args.selectedIndex === 3) {
        this.right.crumb = `${this.$t('Alarm.alarmManage')}/${this.$t('Alarm.historyAlarm')}/${this.$t('Alarm.statistics')}`;
      } else {
        this.right.crumb = `${this.$t('Alarm.alarmManage')}/${this.$t('Alarm.historyAlarm')}`;
        this.$refs.alarmCount.getAlarmCount();

      }
    },
    beforeRemoving(args) {
      if (args.removedIndex === 3) {
        args.cancel = true;
        this.$refs.tabRef.ej2Instances.hideTab(3, true);
      }
    },
    notice(type) {
      switch (type) {
        case 'refresh':
          this.$refs.alarmTable.queryConditions.conditions = '';
          this.$refs.alarmTable.queryConditions.keywords = '';
          this.$refs.alarmTable.page.pageNo = "1";
          this.$refs.alarmTable.getAlarmListData();
          // this.$refs.alarmCount.getAlarmCount();

          break;
        case 'refreshTable':
          this.$refs.alarmTable.page.pageNo = "1";
          this.$refs.alarmTable.getAlarmListData();
          // this.$refs.alarmCount.getAlarmCount();
          break;
        case 'conditions':
          this.$refs.alarmTable.conditionsStatus = true;
          this.$refs.alarmTable.getAlarmListData(true);
          // this.$refs.alarmCount.getAlarmCount();
          break;
        case 'keywords':
          this.$refs.alarmTable.conditionsStatus = false;
          this.$refs.alarmTable.getAlarmListData(true);
          // this.$refs.alarmCount.getAlarmCount();
          break;
        case 'export':
          this.$refs.alarmTable.exportAlarmListData();
          break;
        case 'exportAll':
          this.$refs.alarmTable.exportAllAlarmListData();
          break;
        case 'showDetail':
          this.$refs.alarmTable.showDetail();
          break;
        case 'statistics':
          this.staticsTabFunc();
          break;
        case 'filter':
          this.$refs.alarmTable.filterFunc();
          break;
        default:
      }
    }
  },
  beforeMount() {
    const This = this;
    This.roleNetMap = {};
    This.roleNetList = [];
    this.$axios.get('/lte/ems/auth/findNodeIdByAuth').then((response) => {
      if (response && response.status === 200) {
        for (let i = 0; i < response.data.length; i++) {
          //nodeId为0代表网管内部告警，为了便于查询到数据，所以做了逻辑补充
          if (!response.data.includes(0)) {
            response.data.push(0);
          }
          This.roleNetMap[response.data[i]] = 1;
          This.roleNetList.push(response.data[i]);
        }
      }
    });
  },
  mounted() {
    this.$refs.tabRef.ej2Instances.hideTab(3, true);
  }
};
</script>
